import {AxiosPromise} from "axios";
import RequestHelper, {ActionAnswer, CommandData} from "../utils/RequestsHelper";

export interface PriceAnswer {
    shop_sku_id: number
    product_id: string
    offer_id: string
    product_name: string
}

export interface PricesInfo {
    page: number,
    pageCount: number,
    totalPages: number,
    prices: PriceAnswer[]
}

export default class PricesHistoryApi {
    public static history(pagination: {page:number, pageCount:number, filter?:boolean, query?:string}): AxiosPromise<ActionAnswer<PricesInfo>> {
        return RequestHelper.send("get", "priceSettings&action=pricesHistory", pagination)
    }

    public static productData(data: {id: number|undefined, page:number, pageCount:number}): AxiosPromise<ActionAnswer> {
        return RequestHelper.send("get", "priceSettings&action=productPriceData", data)
    }


}